<template>
    <v-card tile
            flat
            class="pa-7">

        <template v-if="loading">
            <p v-html="$vuetify.lang.t(desc)" :class="{ 'mb-0': !btnUrl }"></p>
            <div class="text-center" v-if="btnUrl">
                <v-btn :to="btnUrl"
                       class="primary align-self-center">{{ $vuetify.lang.t(btnText) }}
                </v-btn>
            </div>
        </template>
        <template v-else>
            <v-skeleton-loader type="paragraph@2" flat class="mb-5"/>
            <v-skeleton-loader type="button" tile flat class="d-flex justify-center"/>
        </template>
    </v-card>
</template>
<script>
    export default {
        name: 'info-card',
        props: {
            desc: {},
            btnUrl: {},
            btnText: {},
            loading: {
                default: true,
            },
        },
    }
</script>
